import { defineNuxtPlugin } from '#app';
import fadeDirective from '~/directives/fade';

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.directive('fade', fadeDirective);
});